import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function NotificationsHorizontal() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('https://physiodirectory.in/api/notifications')
      .then(res => setNotifications(res.data.notifications || []))
      .catch(() => setNotifications([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="mb-4 section-block">
      <div className="section-title-row pt-3 d-flex flex-column align-items-start">
        <div className="text-muted mb-0" style={{fontSize: '1rem', lineHeight: 1.2}}>Latest Updates</div>
        <h5 className="fw-bold mt-1 mb-0 text-dark">Notifications</h5>
      </div>
      {loading ? (
        <div className="text-center py-3">Loading...</div>
      ) : notifications.length === 0 ? (
        <div className="text-muted">No notifications found</div>
      ) : (
        <div className="horizontal-scroll-section">
          {notifications.slice(0, 6).map(n => (
            <div className="horizontal-card" key={n.id} style={{ minWidth: '320px', maxWidth: '320px' }}>
              <div className="card h-100 shadow-sm border-0 notification-card-web">
                <div className="notification-image-wrapper" style={{height: '140px', overflow: 'hidden', borderTopLeftRadius: '12px', borderTopRightRadius: '12px'}}>
                  <img src={n.image ? n.image : '/assets/notification-default.png'} alt={n.title} style={{width: '100%', height: '100%', objectFit: 'cover', borderTopLeftRadius: '12px', borderTopRightRadius: '12px'}} onError={e => {e.target.onerror=null; e.target.src='/assets/notification-default.png';}} />
                </div>
                <div className="card-body p-3 d-flex flex-column">
                  <h6 className="fw-bold mb-1" style={{ fontSize: '1.1rem', color: '#2d3748' }}>{n.title}</h6>
                  <div className="text-muted small mb-1">{n.date}</div>
                  <div className="mb-2 text-truncate">{n.description}</div>
                  <button
                    className="btn btn-outline-primary w-100 rounded-pill fw-semibold mt-auto"
                    style={{fontSize: '0.95rem'}}
                    onClick={() => {
                      const url = `https://physiodirectory.in/notifications/${n.id}`;
                      if (window.ReactNativeWebView) {
                        window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'openExternal', url }));
                      } else {
                        window.location.href = url;
                      }
                    }}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))}
          {/* View All Card */}
          <div className="horizontal-card" style={{ minWidth: '160px', maxWidth: '160px' }}>
            <Link to="/notifications" className="card h-100 shadow-sm border-0 view-all-card d-flex flex-column align-items-center justify-content-center text-center p-3" style={{ cursor: 'pointer', borderRadius: '16px', background: '#e3f2fd', textDecoration: 'none', height: '100%' }}>
              <div className="icon-circle mb-3 bg-white text-primary rounded-circle shadow-sm d-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }}>
                <i className="bi bi-arrow-right" style={{ fontSize: '1.5rem' }}></i>
              </div>
              <h6 className="fw-bold text-dark mb-1">View All</h6>
              <small className="text-muted">Notifications</small>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}

// Add CSS in your main CSS file or Home.css:
// .notification-card-web { border-radius: 12px; overflow: hidden; }
// .notification-image-wrapper img { border-top-left-radius: 12px; border-top-right-radius: 12px; }
